import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ArrowRight } from "lucide-react";

/**
 * CtaFinalSection — banner burgundy con CTA principal y secundario (contacto).
 */
export function CtaFinalSection({ primaryCtaHref }) {
  return (
    <section className="cta-burgundy-gradient text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 dot-pattern pointer-events-none" aria-hidden="true" />
      <div className="relative container-prose py-20 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">
            Empieza ahora
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl mb-4 leading-tight">
            Tu primer caso prevalidado en menos de 5 minutos.
          </h2>
          <p className="text-white/85 max-w-xl leading-relaxed">
            Crea una cuenta gratis, registra tu caso y recibe una prevalidación inmediata.
            Sube a Diagnóstico o Kit Documental cuando lo necesites.
          </p>
        </div>
        <div className="md:col-span-5 flex flex-col sm:flex-row md:flex-col gap-3 md:items-end">
          <Button
            asChild
            size="lg"
            className="rounded-sm h-12 px-8 bg-brand-coral hover:bg-[#d96544] text-white shadow-lg text-sm tracking-wide w-full sm:w-auto md:w-full font-semibold"
            data-testid="landing-final-cta"
          >
            <Link to={primaryCtaHref}>
              Prevalidar mi caso gratis
              <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </Link>
          </Button>
          <a
            href="mailto:contacto@procure.justsapiens.com"
            className="inline-flex items-center justify-center h-12 px-8 border border-white/30 text-white hover:bg-white/10 rounded-sm text-sm tracking-wide transition-colors w-full sm:w-auto md:w-full"
            data-testid="landing-contact-cta"
          >
            Hablar con el equipo
          </a>
        </div>
      </div>
    </section>
  );
}
